import { render, staticRenderFns } from "./loyalty.vue?vue&type=template&id=0157de44&scoped=true"
import script from "./loyalty.vue?vue&type=script&lang=js"
export * from "./loyalty.vue?vue&type=script&lang=js"
import style0 from "./loyalty.vue?vue&type=style&index=0&id=0157de44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0157de44",
  null
  
)

export default component.exports